import { environment as stores } from './environment.stores';
import { environment as defaultEnvironment } from './environment.defaults';

export const environment = {
  ...stores,
  ...defaultEnvironment,
  name: 'int',
  production: false,
  glueApiUrl: [
    { store: 'AU', url: 'https://int.au.glue.backoffice.siemens-healthineers.com'},
    { store: 'BR', url: 'https://int.br.glue.backoffice.siemens-healthineers.com'},
    { store: 'CA', url: 'https://int.ca.glue.backoffice.siemens-healthineers.com'},
    { store: 'GB', url: 'https://int.gb.glue.backoffice.siemens-healthineers.com'},
    { store: 'IN', url: 'https://int.in.glue.backoffice.siemens-healthineers.com'},
    { store: 'US', url: 'https://int.us.glue.backoffice.siemens-healthineers.com'},
    { store: 'JP', url: 'https://int.jp.glue.backoffice.siemens-healthineers.com'},
    { store: 'EU', url: 'https://int.eu.glue.backoffice.siemens-healthineers.com'}
  ],
  auth0Config: {
    domain: 'shs.login-qa.siemens-healthineers.com',
    client_id: 'CCixiF2xImf5zUvD51amZn403ZCcDms1',
    useRefreshTokens: true,
    audience: 'int.br.glue.siemens-healthineers.com',
  },
  contactSettings: {
    phoneNumber: '08000554838',
    email: 'shop.br@siemens-healthineers.com'
  },
};
